// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"to-z","breadcrumbForward":"uo-z","breadcrumbBack":"vo-z","selected":"wo-z"};